import { take, put, fork, call } from 'redux-saga/effects';
import {
  FETCH_LOGIN_DETAILS,
  LOGIN_FAILURE,
  SEND_OTP,
  OTP_NOT_SENT,
  RESET_STATE,
  GET_HISTORY,
  RESEND_OTP,
  SEND_OTP_LOGIN
} from '../actions/actionConstants'
import { post } from '../api';


function* getUserLoginSaga() {
  while (true) {
    const request = yield take(FETCH_LOGIN_DETAILS);
    const { payload } = request;
    const fetchDataResponse = yield call(
      post,
      '/user/login', payload);
    if (fetchDataResponse.status >= 400 || fetchDataResponse.status >= 401) {
      yield put({
        type: LOGIN_FAILURE,
        error: fetchDataResponse.body.errors[0],
      });
      console.log('Err Response from Saga: ', fetchDataResponse.body.errors[0])
    }
    else if (fetchDataResponse.status === 200 || fetchDataResponse.status === 201) {
      let url = window.location.search
      let searchParams = new URLSearchParams(url)
      let redirectUrl = searchParams.get('redirectUrl')
      window.location.href = redirectUrl
      // yield put({
      //   type: LOGIN_SUCCESS,
      //   data: fetchDataResponse.data.data.results,
      // });
      // console.log('Data Response from Saga: ',fetchDataResponse.data.data.results)
    }
  }
}

function* sendOTPSaga() {
  while (true) {
    const history = yield take(GET_HISTORY);
    const request = yield take(SEND_OTP);
    const { payload } = request;
    const fetchDataResponse = yield call(
      post,
      '/user/otp', payload);
    if (fetchDataResponse.status >= 400 || fetchDataResponse.status >= 401) {
      yield put({
        type: OTP_NOT_SENT,
        error: fetchDataResponse.body.errors[0],
      });
      console.log('Err Response from Saga: ', fetchDataResponse.body.errors[0])
    }
    else if (fetchDataResponse.status === 200 || fetchDataResponse.status === 201) {

      yield put({
        type: RESET_STATE,
      });
      history.obj.push('/signin/user/v1/passwordReset')
    }
  }
}

function* sendLoginOTPSaga() {
  while (true) {
    const history = yield take(GET_HISTORY);
    const request = yield take(SEND_OTP_LOGIN);
    const { payload } = request;
    const fetchDataResponse = yield call(
      post,
      '/user/login/otp', payload);
    if (fetchDataResponse.status >= 400 || fetchDataResponse.status >= 401) {
      yield put({
        type: OTP_NOT_SENT,
        error: fetchDataResponse.body.errors[0],
      });
      console.log('Err Response from Saga: ', fetchDataResponse.body.errors[0])
    }
    else if (fetchDataResponse.status === 200 || fetchDataResponse.status === 201) {

      yield put({
        type: RESET_STATE,
      });
      const searchLocation = JSON.parse(window.localStorage.getItem('searchLocation'))
      history.obj.push('/signin/user/v1/confirmOTP'+searchLocation)
    }
  }
}

export default function* () {
  yield fork(getUserLoginSaga);
  yield fork(sendOTPSaga);
  yield fork(sendLoginOTPSaga);

}



// WEBPACK FOOTER //
// ./src/sagas/LoginPageSaga.js